import css from '@emotion/css';
import theme from '../../theme';

export const standAloneButtonsStyles = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .MuiToggleButton-root {
    border: 1px solid ${theme.palette.border.primary};
    border-radius: 25px;
  }
`;

export const columnDirectionStyles = css`
  flex-direction: column;
`;
